import React from 'react';
import PropTypes from 'prop-types';

import StepStatic from './StepStatic';
import StepSession from './StepSession';

export default function Index({ steps, readOnly }) {
  return (
    <div className="selected-topics-wrapper counting-icons-wrapper">
      {steps.map((step) => (
        <div key={step.id}>
          { (step.step_type === 'session' || step.step_type === 'ai_session') && (
            <StepSession
              key={`session-step-${step.position}`}
              step={step}
              topic={step.topic}
              readOnly={readOnly}
            />
          )}

          {step.step_type === 'first_cpa' && (
            <StepStatic
              key="step-first-cpa"
              step={step}
              iconClassName="career-pulse-assessment-icon"
              wrapperClassName="align-items-start"
            />
          )}

          {step.step_type === 'middle_cpa' && (
            <StepStatic
              key="step-middle-cpa"
              step={step}
              iconClassName="career-pulse-assessment-icon"
            />
          )}

          {step.step_type === 'last_cpa' && (
            <StepStatic
              key="step-last-cpa"
              step={step}
              iconClassName="career-pulse-assessment-icon"
            />
          )}

          {step.step_type === 'coach_feedback' && (
            <StepStatic
              key="step-coach-feedback"
              step={step}
              iconClassName="star-filled-icon"
            />
          )}

          {step.step_type === 'program_feedback' && (
            <StepStatic
              key="step-program-feedback"
              step={step}
              iconClassName="star-filled-icon"
            />
          )}

          {step.step_type === 'matrix' && (
            <StepStatic
              key="step-priority-matrix"
              step={step}
              iconClassName="priority-matrix-icon"
              wrapperClassName="align-items-end"
            />
          )}
        </div>
      ))}
    </div>
  );
}

Index.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  readOnly: PropTypes.bool,
};

Index.defaultProps = {
  readOnly: false,
};
